import * as React from "react";
import { Icon } from "@nju/icons";
import { Separator } from "@nju/ui";
import { Text } from "@nju/ui";

export interface ILoginElementProps {
  login: string | undefined;
}

export function LoginElement({ login }: ILoginElementProps) {
  return (
    <div className="flex items-start">
      <div className="w-full grid gap-4 grid-cols-1 grid-rows-auto auto only-tablet:gap-6 from-desktop:gap-12 from-desktop:grid-cols-1-1 from-desktop:grid-rows-1 only-tablet:pb-4">
        <div className="items-center">
          <div className="flex items-center flex-row">
            <Icon
              className="mr-3 w-[24px] h-[24px] from-tablet:w-[32px] from-tablet:h-[32px]"
              name="key"
              tone="accent"
            />
            <Text
              size={{
                "@onlyMobile": "m",
                "@fromTablet": "xl",
              }}
              weight="bold"
            >
              dane dla technika podczas instalacji
            </Text>
          </div>
          <Separator size="xs" />
          <div className="py-1 flex justify-between only-mobile:flex-col from-tablet:flex-row">
            <span className="text-size-16 pr-2 from-tablet:text-size-20">
              login
            </span>
            <Text
              size={{
                "@onlyMobile": "m",
                "@fromTablet": "l",
              }}
              weight="bold"
            >
              {login}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
}
